@if (v2) {
    <div class="form-control-us-switcher d-flex justify-content-between align-items-center">
        <div class="d-flex us-switcher-label">
            <span class="us-switcher-label-text">{{ content?.label }}</span>
            <span class="d-flex align-items-center" [placement]="NgxFloatUiPlacements.TOP" [floatUi]="popper.content">
                <vn-icon name="theme-info-i" extraClass="d-flex align-items-center" size="16" (click)="trackRememberMeTooltip()" />
            </span>
            <vn-popper-content cssClass="tooltip-info" #popper>
                <ng-container content>{{ content?.toolTip }}</ng-container>
            </vn-popper-content>
        </div>
        <div class="switcher-lg">
            <ds-switch id="rememberMe" name="rememberMe" [checked]="value" (checkedChange)="toggleRememberMe($event)" />
        </div>
    </div>
} @else {
    <div class="form-element">
        <input
            type="checkbox"
            class="custom-control-input custom-control-checkbox"
            name="rememberMe"
            (change)="changeRememberMe($event)"
            [checked]="value"
            id="rememberMe" />
        <label for="rememberMe">{{ content?.label }}</label>
    </div>
}
